import { useState } from "react"

export const useTabsPredictions = (initialValue: number = 1) => {
  const [ToggleState, setToggleState] = useState(initialValue);
  const [tagName, setName] = useState("Predice tus marcadores");
  const toggleTab = (index: number, currentName: string) => {
    setToggleState(index)
    setName(currentName)
  };
  const getActiveClass = (index: number, className: any) => ToggleState === index ? className : "";
  return {
    toggleTab,
    getActiveClass,
    tagName
  }
}